import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-12 md:py-20 px-4 bg-white" data-id="element-114">
      <div className="max-w-3xl mx-auto" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl text-warmBrown" data-id="element-116">
          <p className="font-heading text-2xl md:text-3xl leading-relaxed mb-6" data-id="element-117">
            Entrás a tu departamento después de un día larguísimo de laburo.
            Tirás las llaves, caminás al living y lo ves:{' '}
            <span className="text-amber font-bold" data-id="element-118">
              hilitos colgando del apoyabrazos del sillón.
            </span>{' '}
            Otra vez.
          </p>
          <p className="text-lg md:text-xl text-warmBrown/80 leading-relaxed" data-id="element-119">
            Mirás a tu gato. Él te mira con cara de nada. No es maldad, es
            aburrimiento crónico. Tu gato es un tigre viviendo en 40 metros
            cuadrados de cemento, y si no le das algo que cazar, va a cazar tus
            muebles.
          </p>
        </motion.div>
      </div>
    </section>;
}